import moment from "moment";
import {DateInput} from "../data/Calendar";
import {AVAILABLE_NOW} from "@renaissancerentals/renaissance-component/lib/floorplan/service/FloorplanService";

export const isGoogleDriveImage = (imageUrl: string) => imageUrl.includes("drive.google.com");

export const extractIdFrom = (imageUrl: string): string => {

    const paramString = imageUrl.split('?')[1];
    const queryString = new URLSearchParams(paramString);
    const id = queryString.get("id");
    return id === null ? "" : id;

};


export const dateInputArray = () => {
    const months: DateInput[] = [];
    months.push({
        index: AVAILABLE_NOW,
        name: AVAILABLE_NOW
    });
    for (let i = 0; i < 12; i++)
        months.push({
            index: moment().add(i, "month").format('MM-YYYY'),
            name: moment().add(i, "month").format('MMMM')
        });

    return months;
}
